import { mapActions } from 'vuex';
import { getRoutePrefixName } from '@/utils/helpers';
import { LANDING_PAGE_ROUTE } from '@/views/userRegistration/helpers/userRegistration.const';

export default {
	methods: {
		...mapActions(['resendConfirmationEmail']),
		navigateTo(navigationObject) {
			const pageName = navigationObject.name;
			const nameAddition = getRoutePrefixName();
			const name = nameAddition + pageName;
			const newNavObject = {
				...navigationObject,
				name,
				query: { ...this.$route.query, ...navigationObject.query },
				params: { ...this.$route.params, ...navigationObject.params },
			};
			if (!pageName) {
				delete newNavObject.name;
			}
			if (['/', LANDING_PAGE_ROUTE, '/features'].includes(newNavObject.path) && newNavObject.query.return_to) {
				this.$router.push({ path: newNavObject.query.return_to.replace(process.env.VUE_APP_APP_URL, '') });
				return;
			}
			if (!pageName && (newNavObject.path.includes('https:') || newNavObject.path.includes('http:'))) {
				// in case of a full url, dont use vue-router, simply redirect to
				window.location.href = newNavObject.path;
				return;
			}
			this.$router.push(newNavObject);
		},
		resendEmail(dontRedirect) {
			try {
				const { userEmail } = this;
				this.resendConfirmationEmail({ userEmail });
				!dontRedirect && this.navigateTo({ name: 'ResentVerificationEmailSuccessfully', query: { userEmail } });
			} catch (err) {
				console.error(err);
				this.$toast.error(err.response?.data?.error?.msg || 'Error occurred while signing up');
			}
		},
	},
};
